import { Component, OnInit, AfterViewInit, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { NewRelicService } from '../../../../../../angular-app/projects/brokerage-eapp/src/app/services/newrelic.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Subscription, Observable, interval, Subject } from 'rxjs';
import { fadeAnimation } from '../animations';
import * as luxon from 'luxon';

import { QuestionBase } from 'src/app/models/question-base';
import { QuestionControlService } from '../services/question-control.service';
import { QuestionService } from '../services/question.service';
import { ProcessorService } from '../services/processor.service';
import { NavigationService } from '../services/navigation.service';
import { skipValidationFields } from 'src/app/models/data-model';

// models
import { optionsMap } from 'src/app/models/options-map';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { first, takeWhile, startWith, switchMap, takeUntil, debounceTime, mergeMap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

// store
import { AppState } from '../app-reducer';

// util
import { clone, cloneDeep, filter, find, forEach, isEmpty, pickBy, get, concat } from 'lodash';
import { ApiService } from 'src/app/services/api.service';
import { validateSignatureMatch } from 'src/app/validators';
import { CommonService } from '../services/common.service';


@Component({
  selector: 'declarations',
  templateUrl: './declarations.component.html',
  animations: [fadeAnimation]
})
export class DeclarationsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() questions: QuestionBase<any>[] = [];
  declarationsForm: FormGroup;
  sectionBlock: string;
  currentRoute: string;
  sectionData: any;
  optionsMap: any = optionsMap;
  routeSection: any;
  appState$: Observable<any>;
  appStateSubscription: Subscription;
  homeState: null;
  isAgent: boolean;
  isOwner: boolean;
  isInsured: boolean;
  isOmnipotent: boolean;
  isEditable: boolean = true;
  signatureInstructions: string;
  states: any;
  audience: any;
  DateX: any;
  poller: any;
  preFillContent: any = null;
  defaultValues: any = null;
  formData: any = null;
  insuredSignatureReminder: string;
  fullNameDisplay: string;
  fullName: string;
  middleName = '';
  firstName = '';
  lastName = '';
  suffix = '';
  FinalSignatureQuestion = 'FinalSignature';
  AgentFinalSignatureQuestion = 'FinalSignatureAgent';
  docNotCompletedTime = 'The document generation was not completed in the allotted time.';
  mergeNotStarted = 'The specified merge type has not yet been started in the system.';
  appId: string;
  appAuthId: string;
  productName: string;
  agentPreSigned = false;
  public base64Obs;
  htmlLoaded: boolean = false;
  internalInterval: any;
  timeout: number = 3 * 60;
  timeLeft: number = 3 * 60;

  timeElapsed: number;
  didTimeOut = 'false';
  PendingJobsCounter: any = 0;
  counter;
  timedOut = false;
  switchDeclarations = false;
  pdfBase64: string;
  disable = true;
  signatureReady = false;
  agentOnAgentDeclarations = false;
  agentOnInsuredDeclarations = false;
  pendingJobs: any;
  processedQuestions = [];
  sectionMenuData: any;
  menuData: any;
  disableButton: boolean = false;
  private _onDestroy = new Subject();
  declarationsTitle: string = 'Insured/Owner Signature';
  isDemo = false;
  ownerRole = '';
  ownerFinalSignature = '';
  ownerFinalCity = '';
  ownerFinalState = '';
  ownerFinalInstructions = '';
  AgentId: string;
  userRole: string;
  insuredIsOwner = false;
  title = null;

  constructor(
    private newRelicService: NewRelicService,
    public route: ActivatedRoute,
    private store: Store<AppState>,
    private qcs: QuestionControlService,
    private qs: QuestionService,
    private processorService: ProcessorService,
    private navigationService: NavigationService,
    private builder: FormBuilder,
    private apiService: ApiService,
    private matDialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private commonService: CommonService
  ) {
    this.newRelicService.addPageAction('DeclarationsComponent Constructor', { status: 'initialized', appId: this.appId });
    // section data
    this.sectionData = route.snapshot.data;
    this.appState$ = store.select('sections');
    this.currentRoute = route.snapshot.routeConfig.path;
    this.sectionBlock = this.sectionData.blockName;

    // get questions from state
    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {
      let section: any;

      if (state.questions) {
        section = find(state.questions, { Name: this.sectionBlock });

        this.questions = section.Questions;

        // used to inject form with pre-defined default values
        this.defaultValues = this.qs.defaultValues(section, state.userRole);
      }

      this.isDemo = state.isDemo;

      // editing capabilities
      this.isEditable = this.qs.checkIfEditable(get(section, 'QuestionBlockPermissions'), state.userRole, this.isDemo);
      this.setRoles(state);
      this.AgentId = (window['jhConfig'].ivuser !== '') ? window['jhConfig'].ivuser : 'DreamFinFit';
      this.states = state.formData.states;

      // prefill
      const applicationContent = get(state, 'content') || {};
      this.preFillContent = !isEmpty(applicationContent) ? cloneDeep(applicationContent[this.sectionBlock]) : null;

      // create main form
      const preFillArrayMap = this.qcs.generateArrayMap(this.preFillContent);
      this.declarationsForm = this.qcs.toFormGroup(this.questions, false, preFillArrayMap);
      this.formData = state.formData;


      this.setDisplayName(state);

      // populate message on proposed insured declarations page only
      if (this.onInsuredDeclarationsPage()) {
        this.insuredSignatureReminder = 'If changes are needed on your application after the forms have been signed, please contact your insurance agent.';
      }
      this.appId = get(state, 'appId');
      this.productName = state['content']['SECTIONDCoverageDetails']['ProductName'];
      this.agentPreSigned = this.isAgentPresigned(state);
      // if ((this.isAgent || this.isOmnipotent) && state.content.menuData[37].valid && state.content.menuData[38].valid){
      //   state.content.menuData[39].visible = true;
      // };

      state.content.menuData.forEach(block => {

        // Seed menu/validation object with current block's questions
        if (block.name === this.sectionBlock) {
          if (block.questions.length === 0) {
            this.questions.forEach((q, i) => {
              const questionStatus = { 'name': q.QuestionName, 'valid': null, 'visible': false };
              block.questions.push(questionStatus);
            });
          }
          this.sectionMenuData = block;
        }
      });

      this.menuData = state.content.menuData;
      const agentReportBlock = state.content.menuData.findIndex(x => x.name == 'AgentReport');
      const transmittalBlock = state.content.menuData.findIndex(x => x.name == 'TransmittalBlock');
      const declarationsAgentBlock = state.content.menuData.findIndex(x => x.name == 'DeclarationsAgent');

      if (this.agentDeclarationsReady(state, agentReportBlock, transmittalBlock)) {
        state.content.menuData[declarationsAgentBlock].visible = true;
      } else {
        state.content.menuData[declarationsAgentBlock].visible = false;
      };

      if (state["content"]["SECTIONBPolicyOwner"]["PolicyOwnerInsured"] != 'No') {
        this.insuredIsOwner = true;
      }

      this.commonService.logAppState(state);


    });
  }

  isAgentPresigned(state: any): boolean {
    return state['content']['DeclarationsAgent'] && state['content']['DeclarationsAgent']['FinalSignatureAgent'] && state['content']['DeclarationsAgent']['FinalSignatureAgent']['FullName'] && state['content']['DeclarationsAgent']['FinalSignatureAgent']['DateX'] ? true : false;
  }

  setRoles(state: any) {
    this.isAgent = state.userRole.name == 'Agent' ? true : false;
    this.isInsured = state.userRole.name.includes('Insured') ? true : false;
    this.isOwner = state.userRole.name.includes('Owner') && !this.isInsured && !this.isAgent ? true : false;
    this.isOmnipotent = state.userRole.name == 'Omnipotent' ? true : false;
    this.userRole = state.userRole.name;
  }

  agentDeclarationsReady(state: any, agentReportBlock: any, transmittalBlock: any) {
    if (state.content.menuData[agentReportBlock].valid && state.content.menuData[agentReportBlock].visible && state.content.menuData[transmittalBlock].valid && state.content.menuData[transmittalBlock].visible && state.userRole.customerSigned == 1) {
      return true;
    } else if (!state.content.menuData[agentReportBlock].valid || !state.content.menuData[transmittalBlock].valid || !state.content.menuData[agentReportBlock].visible || !state.content.menuData[transmittalBlock].visible) {
      return false;
    }
    return false;
  }

  onInsuredDeclarationsPage() {
    return this.currentRoute && !this.currentRoute.includes('declarations-agent') && !this.currentRoute.includes('owner');
  }

  setDisplayName(state) {
    this.middleName = state['content']['SECTIONAProposedInsured']['Name']['MiddleName'] ? state['content']['SECTIONAProposedInsured']['Name']['MiddleName'].toString().trim() : null;
    this.firstName = state['content']['SECTIONAProposedInsured']['Name']['FirstName'] ? state['content']['SECTIONAProposedInsured']['Name']['FirstName'].toString().trim() : null;
    this.lastName = state['content']['SECTIONAProposedInsured']['Name']['LastName'] ? state['content']['SECTIONAProposedInsured']['Name']['LastName'].toString().trim() : null;
    this.fullName = '';
    this.fullNameDisplay = '';
  }

  ngOnInit() {    
    this.newRelicService.addPageAction('DeclarationsComponent ngOnInit', { status: 'initialized', appId: this.appId });
    // subscribe to observable used for disabling the "Next" button from child components
    this.navigationService.disableButtonStatus().pipe(takeUntil(this._onDestroy)).subscribe((bool) => {
      this.disableButton = bool;
      this.cdr.markForCheck();
    });
    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {
      this.checkAgentOnUnsignedOwnerDeclaration(state);

      // update form with pre-existing values
      this.appAuthId = state.appAuthId;
    });

    const resumePayload = {
      'AppAuthId': this.appAuthId,
      'AppId': this.appId,
      'CheckBlockStatus': false
    };

    if (this.isEditable) {
      this.startApplicationTimer();
      this.checkForPendingJobs(resumePayload);
    }

    if (this.preFillContent) {
      window['setTimeout'](() => {
        this.declarationsForm.patchValue(this.preFillContent);
      }, 350);
    }

    this.DateX = this.preFillContent ? this.preFillContent.DateX : luxon.DateTime.now().toISO();

    this.declarationsForm = this.qcs.toFormGroup(this.questions);
    this.setQuestions();


    // final signature label and validation

    this.questions.forEach(question => {
      if (question.QuestionName == this.audience.instructions) {
        this.signatureInstructions = question.QuestionText;
      }

      this.updateValidation(question);

      if (question.QuestionName == this.FinalSignatureQuestion) {
        this.fullName = this.firstName.trim() + ' ' + (this.middleName ? this.middleName.trim() + ' ' : '') + this.lastName.trim();
        this.fullNameDisplay = '[' + this.fullName + ']';
        this.updateFinalSignature(question.QuestionName);
      } else if (question.QuestionName == this.ownerFinalSignature) {
        this.setOwnerValidation();
      }

      // populate form and menu/validity object for initial view
      const shown = this.showConditionalQuestion(question);
      find(this.sectionMenuData.questions, { 'name': question.QuestionName }) ? find(this.sectionMenuData.questions, { 'name': question.QuestionName }).visible = shown : null;
    });

    // Add hidden field to store DateX value in state to repopulate in visible date field on resume as a formatted date string
    this.declarationsForm.addControl('DateX', this.builder.control(null, null));
    this.declarationsForm.controls['DateX'].setValue(this.DateX);

    // check for customer signed, agent on customer page
    this.setTitles();

    //this.declarationsTitle = this.agentOnAgentDeclarations ? 'Agent Signature' : 'Insured/Owner Signature';

    // Get customer IP Address and build control
    this.getCustomerIpAddress();

  }

  setTitles() {
    if (this.declarationsForm.get('FinalSignature')) {
      this.declarationsTitle = 'Insured Signature';
      if ((this.isAgent || this.isOwner)) {
        this.setAgentViewOnInsuredDeclarations();

        this.pauseApplicationTimer();
        if (this.poller) {
          this.poller.unsubscribe();
        }
        this.navigationService.disableButton(false);
        this.cdr.detectChanges();
      }
    } else if (this.declarationsForm.get(this.ownerFinalSignature)) {
      this.declarationsTitle = 'Owner Signature';
      if (this.isAgent) {
        //console.log('agent on owner declarations');
        this.setAgentViewOnInsuredDeclarations();
        this.pauseApplicationTimer();
        if (this.poller) {
          this.poller.unsubscribe();
        }
        this.cdr.detectChanges();
      }
      // check for agent on agent page
    } else if (this.checkOnAgentDeclarations()) {
      this.declarationsTitle = 'Agent Signature';
      this.agentOnAgentDeclarations = true;
      this.cdr.detectChanges();
    }
  }

  setQuestions() {
    if (this.sectionData.blockName.includes('Owner')) {
      //console.log('this.sectionData.blockName:', this.sectionData.blockName);

      this.ownerRole = this.sectionData.blockName.replace('Declarations', '');
      console.log('ownerRole:', this.ownerRole);
      this.ownerFinalSignature = this.ownerRole.concat('FinalSignature');
      this.ownerFinalCity = this.ownerRole.concat('SignatureOwnerLocationCity');
      this.ownerFinalState = this.ownerRole.concat('SignatureOwnerLocationState');
      this.ownerFinalInstructions = this.ownerRole.concat('SignatureOwnerInstructions');
    }
    // set audience variables for converting template
    this.audience = this.sectionData.blockName == 'DeclarationsInsured' ? {
      signature: 'FinalSignature',
      city: 'SignatureInsuredLocationCity',
      state: 'SignatureInsuredLocationState',
      instructions: 'SignatureInsuredInstructions'
    } :

      (this.sectionData.blockName.includes('DeclarationsOwner')) ? {
        signature: this.ownerFinalSignature,
        city: this.ownerFinalCity,
        state: this.ownerFinalState,
        instructions: this.ownerFinalInstructions
      } :
        {
          signature: 'FinalSignatureAgent',
          city: 'SignatureAgentLocationCity',
          state: 'SignatureAgentLocationState',
          instructions: 'SignatureAgentInstructions'
        }

  }

  checkOnAgentDeclarations() {
    return (this.isAgent && this.declarationsForm.get('FinalSignatureAgent')) || (this.isOmnipotent && this.declarationsForm.get('FinalSignatureAgent'));
  }

  setAgentViewOnInsuredDeclarations() {
    this.agentOnInsuredDeclarations = true;
    this.agentOnAgentDeclarations = false;
  }

  checkAgentOnUnsignedOwnerDeclaration(state: any) {
    if (this.isAgent && !this.sectionData.blockName.includes('Agent')) {
      const unfinishedBlocks = cloneDeep(state.content.menuData.filter(x => x.visible && x.valid != true));
      const visibleBlocks = cloneDeep(state.content.menuData.filter(x => x.visible));
      if (unfinishedBlocks) {
        // if ((unfinishedBlocks[unfinishedBlocks.length -1].name == this.sectionBlock && !this.isEditable) || (unfinishedBlocks.length >= 1 && state.content.menuData.filter(x=> x.name == this.sectionData.blockName)[0].valid && !this.isEditable)){
        if (!this.isEditable && unfinishedBlocks.length >= 1 && visibleBlocks[visibleBlocks.length - 1].name == this.sectionData.blockName) {
          this.navigationService.disableButton(true);
        } else {
          this.navigationService.disableButton(false);
        }
      }
    }
  }

  ngAfterViewInit() {

    // set load timestamp for payload submission
    this.processorService.setServedTime();

  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  setOwnerValidation() {
    const signingLetter = this.ownerRole.replace('Owner', '');

    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {

      if (state.content.signators) {
        const signator = state.content.signators.find(x => x.SignerLetter == signingLetter);
        this.setSignatorDisplayName(signator);
      } else {
        const payload = {
          'AppId': this.appId,
          'AppAuthId': this.appAuthId
        };
        this.apiService.getOwnerSignatories(payload).subscribe(response => {
          if (response.code === 200 && response.data && response.data.OwnershipSignatories) {
            const signator = response.data.OwnershipSignatories.find(owner => owner.SignerLetter == signingLetter);
            if (signator) {
              this.setSignatorDisplayName(signator);
            }
          }
        }, (error) => {
          this.newRelicService.noticeError(error, { appId: this.appId });
        });
      }
    });
  }

  setSignatorDisplayName(signator: any) {
    this.firstName = signator.FirstName;
    // this.middleName = signator.MiddleName;
    this.lastName = signator.LastName;
    this.title = signator.SigningOfficerTitle;
    this.suffix = signator.Suffix;
    const role = signator.Role;
    let fullNameValidation = '';
    if (role == 'EntityTrustee') {
      this.fullName = this.firstName.trim() + ' ' + this.lastName.trim() + (this.suffix ? ' ' + this.suffix.trim() : '');
      fullNameValidation = this.title ? this.fullName + ', ' + this.title.trim() : this.fullName;
      this.fullNameDisplay = '[' + fullNameValidation + ']';
      // this.fullNameDisplay = this.title ? '[' + this.fullName + ', ' + this.title + ']' : '[' + this.fullName + ']';
    } else if (role == 'IndividualTrustee') {
      this.fullName = this.firstName.trim() + ' ' + this.lastName.trim() + (this.suffix ? ' ' + this.suffix.trim() : '');
      fullNameValidation = this.fullName + ', Trustee';
      this.fullNameDisplay = '[' + fullNameValidation + ']';
      // this.fullNameDisplay = '[' + this.fullName + ', Trustee]';
    } else {
      this.fullName = this.firstName.trim() + ' ' + this.lastName.trim();
      // this.fullNameDisplay = this.title ? '[' + this.fullName + ', ' + this.title + ']' : '[' + this.fullName + ']';
      fullNameValidation = this.title ? this.fullName + ', ' + this.title.trim() : this.fullName;
      this.fullNameDisplay = '[' + fullNameValidation + ']';

    }
    fullNameValidation = fullNameValidation.replace(/  +/g, ' ');
    this.updateFinalOwnerSignature(this.ownerFinalSignature, fullNameValidation);
  }
  updateFinalOwnerSignature(ownerFinalSignature: string, fullNameValidation: any) {
    const formField = this.declarationsForm.get(ownerFinalSignature);
    const validationName = fullNameValidation;
    formField.setValidators(Validators.compose([Validators.required, validateSignatureMatch(validationName)]));
    formField.updateValueAndValidity();
  }

  checkForComplete() {
    switch (this.sectionData.blockName) {
      case 'DeclarationsInsured':
        if (this.allFieldsValid('DeclarationsInsured')) {
          this.sectionMenuData.valid = true;
          this.navigationService.updateNav(this.declarationsForm.controls, this.sectionBlock);
          this.cdr.detectChanges();
        } else {
          this.sectionMenuData.valid = null;
        }

      case 'DeclarationsAgent':
        if (this.allFieldsValid('DeclarationsAgent')) {
          this.sectionMenuData.valid = true;
          this.navigationService.updateNav(this.declarationsForm.controls, this.sectionBlock);
          this.cdr.detectChanges();
        } else {
          this.sectionMenuData.valid = null;
        }

      default:
        if (this.allFieldsValid(this.sectionData.blockName)) {
          this.sectionMenuData.valid = true;
          this.navigationService.updateNav(this.declarationsForm.controls, this.sectionBlock);
          this.cdr.detectChanges();
        } else {
          this.sectionMenuData.valid = null;
        }
    }
  }

  allFieldsValid(blockName) {
    switch (blockName) {
      case 'DeclarationsInsured':
        return (this.declarationsForm.controls['FinalSignature'].valid && this.declarationsForm.controls['SignatureInsuredLocationCity'].valid && this.declarationsForm.controls['SignatureInsuredLocationState'].valid);
      case 'DeclarationsAgent':
        return (this.declarationsForm.controls['FinalSignatureAgent'].valid && this.declarationsForm.controls['SignatureAgentLocationCity'].valid && this.declarationsForm.controls['SignatureAgentLocationState'].valid);
      default:
        return (this.declarationsForm.controls[this.ownerFinalSignature].valid && this.declarationsForm.controls[this.ownerFinalCity].valid && this.declarationsForm.controls[this.ownerFinalState].valid);
    }

  }

  checkAgentOnDeclarationPage(): boolean {
    return (
      (((this.isAgent || this.isOwner) && this.currentRoute &&
        this.currentRoute.endsWith('declarations')) ||
        (this.isAgent && this.currentRoute &&
          this.currentRoute.includes('declarations-owner'))
      )
    );
  }

  get localDate() {
    return luxon.DateTime.fromISO(this.DateX).toLocal().toFormat('MM/dd/yyyy');
  }

  getChildQuestions(parent: string) {
    let filteredQuestions = clone(this.questions);
    filteredQuestions = filter(filteredQuestions, { ParentQuestionName: parent });
    return filteredQuestions;
  }

  getTopParentQuestion(QuestionName) {
    const currentQuestion = find(this.questions, { QuestionName });

    const { ParentQuestionName } = currentQuestion;
    if (ParentQuestionName) {
      return this.getTopParentQuestion(ParentQuestionName);
    } else {
      return currentQuestion;
    }
  }

  // update validators for sibling questions
  // reset form value
  updateValidation(question: any) {
    let isRequired = true;
    const formField = this.declarationsForm.get(question.QuestionName);

    const { ParentQuestionName, QuestionType } = question;

    if (ParentQuestionName) {
      const parentQuestion = this.getTopParentQuestion(ParentQuestionName);
      isRequired = this.processorService.showConditionalQuestion(parentQuestion, this.questions, this.declarationsForm.value);
    } else {
      isRequired = this.processorService.showConditionalQuestion(question, this.questions, this.declarationsForm.value);
    }

    const validateFields = [
      'FinalSignature',
      'SignatureInsuredInstructions',
      'SignatureInsuredLocation',
      'SignatureInsuredLocationCity',
      'SignatureInsuredLocationState',
      'SignatureAgentInstructions',
      'SignatureAgentLocation',
      'SignatureAgentLocationCity',
      'SignatureAgentLocationState',
      'FinalSignatureAgent',
      this.ownerFinalSignature,
      this.ownerFinalCity,
      this.ownerFinalState,
      this.ownerFinalInstructions
    ];

    if (isRequired && question.QuestionType.trim() !== 'Compound' && question.IsOptional === null
      && validateFields.includes(question.QuestionName)) {
      formField.setValidators([Validators.required]);
      formField.updateValueAndValidity({ emitEvent: false });
    } else {
      formField.clearValidators();
      formField.updateValueAndValidity({ emitEvent: false });
    }
  }

  /**
   * Check ConditionalClause then ParentQuestion ConditionalClause if available.
   * @param question - question object
   * @returns boolean
   */
  showConditionalQuestion(question) {

    const doNotDisplay = ['SignatureInsuredInstructions', 'SignatureInsuredLocation', 'SignatureInsuredLocationCity', 'SignatureInsuredLocationState', 'SignatureAgentInstructions', 'SignatureAgentLocation', 'SignatureAgentLocationCity', 'SignatureAgentLocationState'];
    const doNotDisplayOwner = ['SignatureOwnerInstructions', 'SignatureOwnerLocation', 'SignatureOwnerLocationCity', 'SignatureOwnerLocationState'];
    if (doNotDisplay.includes(question.QuestionName)) {
      return false;
    } else {
      doNotDisplayOwner.forEach(q => {
        if (question.QuestionName.includes(q)) {
          return false;
        }
      });
    }
  
    // this.processorService.enableComments(question.QuestionName === 'SignatureInsured1035Internal' ? true : false);

    // Added because change detection implemented for PDF polling caused ConditionalClause analysis to loop indefinitely
    // and conditionality for Declarations should be static since there are no inputs on the page that affect this conditionality
    if (this.processedQuestions.hasOwnProperty(question.QuestionName)) {
      return this.processedQuestions[question.QuestionName];
    }
  
    // this.processorService.enableComments(question.QuestionName === 'SignatureInsured1035Internal' ? true : false);

    // Populate QuestionTextAlt based on AlternativeQuestionText ConditionalClause
    if (question.QuestionVariations) {
      question.QuestionVariations.forEach(cond => {
        if (this.processorService.analyzeConditionalArray(cond.ConditionalClause, this.questions, this.declarationsForm.value)) {
          question.QuestionTextAlt = cond.AlternativeQuestionText ? cond.AlternativeQuestionText : ' ';
        }
      });
    }
  
    const result = this.processorService.showConditionalQuestion(question, this.questions, this.declarationsForm.value);
  
    this.processedQuestions[question.QuestionName] = result;
  
    return result;
  }
  
  // next section / form submit
  onSubmit({ value, valid, controls }: { value: any, valid: boolean, controls: any }) {
    this.newRelicService.addPageAction('Form Submit Start (declarations)', { appId: this.appId });
  
    if (this.isEditable) {
      this.declarationsForm.markAllAsTouched();
  
      if (this.processorService.noValidation()) {
        this.sanitizePayload(controls);
      }
  
      this.sectionMenuData.valid = valid;
    }
    // this.cdr.detectChanges;
  
    if (!valid && this.isEditable) {
      this.processorService.goToError();
  
      let invalidInput: any = pickBy(controls, (val, key) => val.invalid);
  
      invalidInput = Object.keys(invalidInput);
  
      const skipValidation = filter(invalidInput, field => skipValidationFields.includes(field) ? false : true);
      // console.log('skipValidation', skipValidation);
  
      if (skipValidation.length === 0) {
        this.goForward();
      }
  
      this.newRelicService.addPageAction('Form Submit Invalid', { appId: this.appId });
      return false;
    }
  
    // Updates the menuData object with question visibility and validity
    this.navigationService.updateNav(cloneDeep(controls), this.sectionBlock);
  
    if (this.isEditable) {
      // sanitize and go to next section
      this.sanitizePayload(controls);
    } else {
      // skip sanitizing because nothing gets submitted or saved
      this.goForward();
    }
  
    this.newRelicService.addPageAction('Form Submit Success', { appId: this.appId });
  }
  
  // apply final signature to required questions
  sanitizePayload(controls) {
    const sigVal = this.declarationsForm.value[this.audience.signature];
    //console.log('Didtimeout', this.didTimeOut);
    //console.log('LoadTime', this.timeElapsed);
    //set hidden values to send to jhade
    this.questions.forEach(question => {
      if (question && this.sectionData.blockName == 'DeclarationsInsured' && !this.isAgent && !this.isOwner) {
        this.setTimeInfo(question.QuestionName, 'Insured');
      } else if (question && this.agentOnAgentDeclarations) {
        this.setTimeInfo(question.QuestionName, 'Agent');
      } else if (question && this.sectionData.blockName.includes('DeclarationsOwner') && this.isOwner) {
        this.setTimeInfo(question.QuestionName, 'Owner');
      }
    });
    //
    forEach(controls, (control, key) => {
      const question = this.qcs.getQuestion(this.questions, key);
      if (question && question.QuestionType == 'Signature') {
        control.value = this.showConditionalQuestion(question) ? sigVal.trim() : null;
        control.updateValueAndValidity();
      }
    });
    if (this.disable == false) {
      this.goForward();
    }
  }
  setTimeInfo(questionName: string, page: any) {
    switch (page) {
      case 'Insured':
        if (questionName == 'InsuredLoadTime') {
          this.declarationsForm.get('InsuredLoadTime').setValue(this.timeElapsed.toString());
        } else if (questionName == 'InsuredTimeOut') {
          this.declarationsForm.get('InsuredTimeOut').setValue(this.didTimeOut);
        }
      case 'Agent':
        if (questionName == 'AgentLoadTime') {
          this.declarationsForm.get('AgentLoadTime').setValue(this.timeElapsed.toString());
        } else if (questionName == 'AgentTimeOut') {
          this.declarationsForm.get('AgentTimeOut').setValue(this.didTimeOut);
        }
      case 'Owner':
        if (questionName == this.ownerRole.concat('OwnerLoadTime')) {
          this.declarationsForm.get(this.ownerRole.concat('OwnerLoadTime')).setValue(this.timeElapsed.toString());
        } else if (questionName == this.ownerRole.concat('OwnerTimeOut')) {
          this.declarationsForm.get(this.ownerRole.concat('OwnerTimeOut')).setValue(this.didTimeOut);
        }
    }
  }
  
  // next section block
  goForward() {
    // udpate form with default values
    this.declarationsForm.patchValue(this.defaultValues);
  
    if (this.isAgent || this.isOmnipotent || (this.isOwner && this.checkAgentOnDeclarationPage() && !this.agentPreSigned)) {
      this.navigationService.takeMeTo(this.declarationsForm.value, this.isEditable, this.route.snapshot.routeConfig, 'fwd');
    } else {
      if (this.agentPreSigned && !this.isDemo) {
        if (this.isInsured && !this.checkAgentOnDeclarationPage()) {
          this.navigationService.takeMeTo(this.declarationsForm.value, this.isEditable, this.route.snapshot.routeConfig, 'express/processing-external-application');
        } else if (this.checkAgentOnDeclarationPage()) {
          this.navigationService.takeMeTo(this.declarationsForm.value, this.isEditable, this.route.snapshot.routeConfig, 'fwd');
        }
        else if (this.sectionData.blockName.includes('DeclarationsOwner') && this.isOwner) {
          this.navigationService.takeMeTo(this.declarationsForm.value, this.isEditable, this.route.snapshot.routeConfig, 'express/thank-you');
        }
      } else {
        this.navigationService.takeMeTo(this.declarationsForm.value, this.isEditable, this.route.snapshot.routeConfig, 'express/thank-you');
      }
    }
  }
  
  // Oprn PDF new window test
  openPdfInWindow() {
    this.navigationService.disableButton(false);
  
    this.signatureReady = true;
  
    if (this.declarationsForm.get('FinalSignature')) {
      this.declarationsForm.get('FinalSignature').enable();
    }
    if (this.declarationsForm.get('FinalSignatureAgent')) {
      this.declarationsForm.get('FinalSignatureAgent').enable();
    }
  
    const byteArray = new Uint8Array(window.atob(this.pdfBase64).split('').map(char => char.charCodeAt(0)));
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const pdfURL = window.URL.createObjectURL(blob);
  
    this.disable = false;
  
    window.open(pdfURL, '_blank');
  }
  
  private getCustomerIpAddress() {
    this.apiService.getIPAddress().subscribe((res: any) => {
      this.declarationsForm.addControl('customerIpAddress', this.builder.control(null, null));
      this.declarationsForm.controls['customerIpAddress'].setValue(res.ip);
    });
  }
  
  // Updates validation to check for signature matching proposed insured
  updateFinalSignature(questionName, title?: string) {
    const formField = this.declarationsForm.get(questionName);
    let validationName = title ? this.fullName + ', ' + title.trim() : this.fullName;
    // console.log('VALIDATION NAME:' , validationName);
    validationName = validationName.replace(/  +/g, ' ');
    formField.setValidators(Validators.compose([Validators.required, validateSignatureMatch(validationName)]));
    formField.updateValueAndValidity();
  }
  
  checkForPendingJobs(resumePayload: any) {
    this.newRelicService.addPageAction('Check Pending Jobs Start', { appId: this.appId });
    // disable the next button while checking for pending jobs and polling for PDF
    if (this.timeLeft > 0) {
      this.navigationService.disableButton(true);
  
      this.apiService.resumeApplication(resumePayload).pipe(takeUntil(this._onDestroy)).subscribe(response => {
        const count = response.data.PendingJobs === 'jhade' ? 'jhade queue still processing' : response.data.PendingJobs;
        //console.log('pending jobs count', count);
        if (count) {
          if (this.PendingJobsCounter === count) {
            setTimeout(() => this.delayCall(resumePayload), 5000);
          } else {
            this.checkForPendingJobs(resumePayload);
          }
          this.PendingJobsCounter = count;
        } else {
          this.pollPdfApplication();
        }
      }, (error) => {
        this.newRelicService.noticeError(error, { appId: this.appId });
      });
    }
  }
  
  delayCall(resumePayload: any) {
    this.checkForPendingJobs(resumePayload);
  }
  
  pollPdfApplication() {
    this.poller = interval(20000)
      .pipe(
        startWith(0),
        mergeMap(() => {
          //console.log('timeleft:', this.timeLeft);
          const mergeType = this.determineMergeType();
          //console.log('mergeType', mergeType);
          //console.log('this.appId', this.appId);
          this.base64Obs = this.apiService.getApplicationPdf(this.appId, mergeType);
          return this.base64Obs;
        }),
        takeWhile((response: any) => {

          const pdfJson = get(response, 'data');
          const jhadeResponse = get(response, 'response');
          const code = get(response, 'code');
          if (code == 500 && this.checkForFatalError(jhadeResponse)) {
            this.newRelicService.noticeError(new Error('Fatal error'), { appId: this.appId });
            this.htmlLoaded = false;
            this.timeElapsed = this.timeout - this.timeLeft;
            this.didTimeOut = 'true';
            this.timeLeft = 0;
            this.timedOut = true;
            this.pauseApplicationTimer();
            if (this.poller) {
              this.poller.unsubscribe();
            }
            this.cdr.detectChanges();

          }
          const pdfReady = pdfJson.length > 0;
          this.htmlLoaded = false;
          if (pdfReady) {
            this.timeElapsed = this.timeout - this.timeLeft;
            this.didTimeOut = 'false';
            this.htmlLoaded = true;
            this.pdfBase64 = pdfJson;
            this.cdr.detectChanges();
            // stop timer
            this.pauseApplicationTimer();

            // enable the next button after PDF returned
            //            this.navigationService.disableButton(false);
          }
  
          if (this.timeLeft <= 0) {
            this.timeElapsed = this.timeout - this.timeLeft;
            this.didTimeOut = 'true';
            this.timedOut = true;
            console.log('Timed out');
            this.pauseApplicationTimer();

            // enable the next button after PDF poll times out
            this.navigationService.disableButton(false);
          }
          return !(pdfReady);
        })
      ).pipe(takeUntil(this._onDestroy)).subscribe((response: any) => { }, (errorResponse: any) => {
        this.newRelicService.noticeError(errorResponse, { appId: this.appId });
        this.pauseApplicationTimer();
      });
  }
  
  checkForFatalError(response: string) {
    if (response.includes(this.docNotCompletedTime) || response.includes(this.mergeNotStarted)) {
      return false;
    } else { return true; }
  }
  
  startApplicationTimer() {
    clearInterval(this.internalInterval);
    this.timeLeft = this.timeout;
  
    this.internalInterval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        this.counter = this.commonService.toMMSS((this.timeout - this.timeLeft));
        this.cdr.detectChanges();
      }
      if (this.timeLeft == 0) {
        this.pauseApplicationTimer();
        this.timedOut = true;
        if (this.poller) {
          this.poller.unsubscribe();
        }
        console.log('Timed out');
        this.cdr.detectChanges();
      }
    }, 1000);
  }
  
  pauseApplicationTimer() {
    clearInterval(this.internalInterval);
    if (this.poller) {
      this.poller.unsubscribe();
    }
  }
  
  checkRoleAgent() {
    return this.isAgent;
  }
  
  determineMergeType() {
    if (this.isAgent && this.agentOnAgentDeclarations) {
      return 'Agent';
    } else if (this.declarationsForm.get('FinalSignatureAgent')) { //for omnipotent
      return 'Agent';
    } else if (this.isOwner && !this.agentOnInsuredDeclarations) { //if owner on proposed insured page
      return 'OwnerNotInsured';
    } else if (this.declarationsForm.get(this.ownerFinalSignature)) { //for omnipotent
      return 'OwnerNotInsured';
    } else { //insured roles
      if (this.insuredIsOwner) { //for omnipotent
        return 'InsuredOwner';
      }
      else if (this.userRole == 'InsuredOwner') {
        return 'InsuredOwner';
      } else {
        return 'InsuredNotOwner';
      }
    }
  }
  
  switchNoPdfDeclarations() {

    // enable the next button
    this.navigationService.disableButton(false);

    // udpate form with default values
    this.declarationsForm.patchValue(this.defaultValues);
    this.timeElapsed = this.timeout - this.timeLeft;
    this.didTimeOut = 'true';
    this.switchDeclarations = true;
    console.log('Switch to no PDF');
    this.signatureReady = true;
    this.pauseApplicationTimer();
    if (this.declarationsForm.get('FinalSignature')) {
      this.declarationsForm.get('FinalSignature').enable();
    }
    if (this.declarationsForm.get('FinalSignatureAgent')) {
      this.declarationsForm.get('FinalSignatureAgent').enable();
    }
    if (this.declarationsForm.get(this.ownerFinalSignature)) {
      this.declarationsForm.get(this.ownerFinalSignature).enable();
    }
    this.disable = false;
    this.cdr.detectChanges();

  }
  
  submitBlock(form, direction?: string) {
    this.newRelicService.addPageAction('Submit Block Start', { appId: this.appId });
  
    if (this.pendingJobs) {
      this.pendingJobs.unsubscribe();
    }
    this.pauseApplicationTimer();
  
    const { value, valid, controls } = form;
  
    direction = direction ? direction : null;
  
    // sets navigationService observable to hide menu when menu nav is clicked
    if (direction !== 'fwd' && direction !== 'back' && direction !== 'save') {
      this.navigationService.setHideMenu(true);
    }

    this.newRelicService.addPageAction('Moving backwards... signatures not saved or submitted', { appId: this.appId });
    // navigate without saving
    this.navigationService.takeMeTo(this.declarationsForm.value, false, this.route.snapshot.routeConfig, direction);
  }

}
